import React                        from 'react';
import { browserHistory }           from 'react-router';
import GlobalHeader                 from '../Fragments/GlobalHeader';
import SubmitButton                 from '../Fields/SubmitButton';
import BuildingsAccidentalDamage    from '../QuoteSummaryFields/BuildingsAccidentalDamage';
import ExcessBuildingsCover         from '../QuoteSummaryFields/ExcessBuildingsCover';
import ContentsAccidentalDamage     from '../QuoteSummaryFields/ContentsAccidentalDamage';
import ExcessContentsCover          from '../QuoteSummaryFields/ExcessContentsCover';
import IncludeFloodCover            from '../QuoteSummaryFields/IncludeFloodCover';
import AddonSelection               from '../QuoteSummaryFields/AddonSelection';
import FaWrench                     from 'react-icons/lib/fa/wrench';
import FaMedkit                     from 'react-icons/lib/fa/medkit';
import FaCheck                      from 'react-icons/lib/fa/check';
import FaFilePdfO                   from 'react-icons/lib/fa/file-pdf-o';
import FaCross                      from 'react-icons/lib/fa/close';
import PageSpinnerModal             from '../Modals/PageSpinnerModal';
import moment                       from 'moment';

let Quote       = require('../Managers/Quote');
let QuoteError  = require('../Managers/QuoteError');
let Steps  = require('../Managers/Steps');
let ReactGA =       require('react-ga');
let HttpService = require('../Managers/HttpService');
const Config = HttpService.getConfigForHost();
const QuoteSummaryScreen = React.createClass ({
    getInitialState() {
        return {
            IsContinueToPayment : false, 
            isValid : false,
            isAnnualBreakdownActive: false,
            isMonthlyBreakdownActive: false,
            quote: Quote.getQuote(),
            isBoilerChecked: false,
            isEmergencyAssistanceChecked: false,
            isShowBuildingsAccidentalDamageField : false,
            isShowExcessBuildingsCoverField : false,
            isShowPageSpinner : false,
            pageSpinnerMessage : 'Updating your premium...',
            isShowIncludeFloodCoverField : false,
            termsAndConditions: { 
                ps : false
            } 
        };
    },

    componentWillMount() {
        ReactGA.initialize('UA-1926380-5');
        this.isValid = false;
        
        if(this.IsContinueToPayment )
        {
            this.state.termsAndConditions.ps == true;
        }
    },

    componentDidMount() {
        if (Quote.hasQuote()) {
            document.title = "Your Quote";
            window.scrollTo(0, 0);
        } else {
            browserHistory.push('/start');
        }

        // Push event to GA
        ReactGA.event({
            category: 'Landlord Insurance',
            action: 'Quote Summary',
            label: 'Quote Form'
        });

        // convert the current policy start into a moment object, to do a more
        // robust check against the current date
        let momentPolicyStart = moment(Quote.getCurrentAnswer('policy_start'), 'DD/MM/YYYY');
        if (momentPolicyStart.isBefore(moment(), 'day')) {
            Quote.set('policy_start', moment().format('DD/MM/YYYY'));
            this.regenerateQuote('Policy start date cannot be in the past. Updating...');
        }
    },

    checkboxHandler(event){ 

        let state = this.state;
        state.termsAndConditions[event.target.value] = event.target.checked;  
        state.IsContinueToPayment = false; 
        this.setState(state); 
        if(this.state.termsAndConditions.ps == true) 
         { 
            window.localStorage.setItem("termsAndConditions" , "true");
            this.IsContinueToPayment = true; 
            this.isValid = true;
        } 
        if(this.state.termsAndConditions.ps == false) 
        {
            this.isValid = false;
            this.IsContinueToPayment = false; 
        }
    }, 

    QuotePackDoc()
    {
        let policyNumberVal = this.state.quote.policyNumber;
        if (policyNumberVal != null)
        {
            $.ajax({
                type: Config.api.quotePackDocLookUp.method,//POST
                data: jQuery.param({ policyNumber: policyNumberVal}),
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                async: false,
                url: Config.api.quotePackDocLookUp.url,
                success: function(response) {
                    if (response.results != null) {
                        if (response.results.data != null)
                        {
                            window.open(Config.api.homeLetDocUrl.url+ response.results.data, "_blank");
                        }
                        else
                        {                     
                            let win = window.open("about:blank", null);
                            let doc = win.document;
                            doc.open("text/html");
                            doc.write('There is no quote pack is available for this policy '+ policyNumberVal);
                            doc.close();
                        }
                    }
                    else {
                        let win1 = window.open("about:blank", null);
                            let doc1 = win1.document;
                            doc1.open("text/html");
                            doc1.write('Oops! Something went wrong. Please try again after sometime');
                            doc1.close();
                    }
                }.bind(this),
                error: function() {
                    this.setState({
                        displayErrors:['Oops! Something went wrong. Please try again after sometime']
                    });
                    window.scrollTo(0, 0);
                }.bind(this)
            });
        }
    },

    goToPayment() {
            if(this.IsContinueToPayment){ 
                
                browserHistory.push('/payment'); 
            } 
            
    },

    openAnnualBreakdownModal: function() {
        let _this = this;
        _this.setState({
            isAnnualBreakdownActive: true,
        });
    },

    closeAnnualBreakdownModal: function() {
        this.setState({
            isAnnualBreakdownActive: false,
        });
    },

    openMonthlyBreakdownModal: function() {
        let _this = this;
        _this.setState({
            isMonthlyBreakdownActive: true,
        });
    },

    closeMonthlyBreakdownModal: function() {
        this.setState({
            isMonthlyBreakdownActive: false,
        });
    },

    handleBoilerClick() {
        if (true === this.state.isBoilerChecked) {
            this.setState({ isBoilerChecked: false });
            document.getElementById('need_boiler_heating').checked = false;
            window.setLocalStorageAnswer('need_boiler_heating', 'no');
        } else {
            this.setState({ isBoilerChecked: true });
            document.getElementById('need_boiler_heating').checked = true;
            window.setLocalStorageAnswer('need_boiler_heating', 'yes');
        }
    },

    handleEmergencyAssistanceClick() {
        if (true === this.state.isEmergencyAssistanceChecked) {
            this.setState({ isEmergencyAssistanceChecked: false });
            document.getElementById('need_emergency_assistance').checked = false;
            window.setLocalStorageAnswer('need_emergency_assistance', 'no');
        } else {
            this.setState({ isEmergencyAssistanceChecked: true });
            document.getElementById('need_emergency_assistance').checked = true;
            window.setLocalStorageAnswer('need_emergency_assistance', 'yes');
        }
    },

    moveBack() {
        Steps.setCurrentStep(Steps.totalNumberOfSteps() - 1);
        if(Steps.setCurrentStep(Steps.totalNumberOfSteps() - 1) == 4 )
        {
            if(window.localStorage.getItem("termsAndConditions") != 'null' && window.localStorage.getItem("termsAndConditions") == 'true')
            {
                this.state.termsAndConditions.ps == true;
            }

        }
        this.IsContinueToPayment = true;
        browserHistory.push('/questions');
    },

    moveToStep(stepIndex) {
        Steps.setCurrentStep(stepIndex);
        this.moveBack();
    },

    showBuildingsAccidentalDamageField : function() {
        this.setState({
            isShowBuildingsAccidentalDamageField : true
        });
    },

    showExcessBuildingsCoverField : function() {
        this.setState({
            isShowExcessBuildingsCoverField : true
        });
    },

    showContentsAccidentalDamageField : function() {
        this.setState({
            isShowContentsAccidentalDamageField : true
        });
    },

    showExcessContentsCoverField : function() {
        this.setState({
            isShowExcessContentsCoverField : true
        });
    },

    showIncludeFloodCoverField : function() {
        this.setState({ isShowIncludeFloodCoverField : true });
    },

    showPageSpinner : function() {
        this.setState({
            isShowPageSpinner : true,
        });
    },

    getCoversOnPolicyFormattedString : function() {
        let covers = [];
        if (this.state.quote.need_building_insurance === 'yes') {
            covers.push('Buildings');
        }
        if (this.state.quote.need_contents_insurance === 'yes') {
            covers.push('Contents');
        }
        if (this.state.quote.need_prestige_rent_guarantee === 'yes') {
            covers.push('Rent Guarantee, Legal Expenses');
        }
        if (this.state.quote.need_legal_expenses === 'yes' && this.state.quote.need_prestige_rent_guarantee === 'no') {
            covers.push('Legal Expenses');
        }
        return covers.join(', ');
    },

    regenerateQuote : function(m) {
        let _this = this;

        this.setState({
            isShowPageSpinner : true,
            pageSpinnerMessage: m ? m : 'Updating your premium...',
        });

        // FAKING A PROMISE
        // @NOTE this is because everything in React is async
        setTimeout(() => {
            // generate a quote with the new answers
            Quote.generateQuote(Config.api.quote.method, Config.api.quote.url).then(
                function(s) {
                    if (typeof s.results === 'object') {
                        Quote.cacheQuote(s.results);
                        _this.refs.GlobalHeader.updateQuoteState(s.results);
                        _this.setState({
                            isShowPageSpinner : false,
                            quote : s.results,
                            isShowBuildingsAccidentalDamageField: false,
                            isShowExcessBuildingsCoverField: false,
                            isShowContentsAccidentalDamageField: false,
                            isShowExcessContentsCoverField: false,
                        });
                    }
                },
                // if something goes wrong
                function(e) {
                    _this.setState({
                        isShowPageSpinner : false,
                    });
                    if (e.status === 500) {
                        QuoteError.set(QuoteError.getStatusFromString(e.responseJSON.error), e.responseJSON.error, null);
                        browserHistory.push('/quote-recoverable-issue');
                    }
                });
        }, 500);

    },

    renderExcessStaticText(type) {
        return (
            <div>
                <p>The excess you choose will apply to all aspects apart from:</p>
                <ul>
                    <li>&pound;500 excess for Malicious Act or Accidental Damage by tenant (if policy option selected)</li>
                    <li>&pound;500 excess for Malicious Act by a third party</li>
                    <li>&pound;1,000 excess for Subsidence, Landslip or Heave</li>
                </ul>
                <p>However, if you&rsquo;ve selected the Nil Excess option (&pound;0) the excess will be zero for any {type} claim you make.</p>
            </div>
        );
    },

    render() {
        // Derived premiums
        let annualFullContents = this.state.quote.derived_premiums.annual_full_contents;
        let annualLimitedContents = this.state.quote.derived_premiums.annual_limited_contents;
        let annualContentsAccidentalDamage = this.state.quote.derived_premiums.annual_contents_accidental_damage;
        let annualBoilerAndHeating = this.state.quote.derived_premiums.annual_boiler_and_heating;
        let annualEmergencyAssistance = this.state.quote.derived_premiums.annual_emergency_assistance;
        let annualRentGuarantee = this.state.quote.derived_premiums.annual_rent_guarantee;
        let annualLegalExpenses = this.state.quote.derived_premiums.annual_legal_expenses;
        let annualIpt = this.state.quote.derived_premiums.annual_ipt;
        let annualBuildings = this.state.quote.derived_premiums.annual_buildings;
        let annualBuildingsAccidentalDamage = this.state.quote.derived_premiums.annual_buildings_accidental_damage;
        let annualBuildingsFlood = this.state.quote.derived_premiums.annual_buildings_flood;
        let annualContentsFlood = this.state.quote.derived_premiums.annual_contents_flood;
       
        // annualBuildingsFlood=10;
        // annualContentsFlood=10;
        // console.log("annulabuildingsflood",annualBuildingsFlood);
        // console.log("annulacontentsflood",annualContentsFlood);

        // if(Quote.getCurrentAnswer("Buildings_Flood")=="yes"){
        //     annualBuildingsFlood= annualBuildingsFlood * 1.25;
        //     console.log("annulabuildingsflood1.25",annualContentsFlood);
        // }

        // if(Quote.getCurrentAnswer("Contents_Flood")=="yes"){
        //     annualContentsFlood= annualContentsFlood * 1.25;
        //     console.log("annulacontentsflood1.25",annualContentsFlood);
        // }
       

        return (
            <div>
                <GlobalHeader
                    ref="GlobalHeader"
                    isSummary={true}
                />

                <div className="container summary-start stepless">
                    <div className="summary-row">
                        <div className="summary-column">
                            <h1>Your Quote: {this.state.quote.policyNumber}</h1>
                        </div>
                    </div>
                </div>
                <div className="container">
                <p className="pad115">This insurance quote has been offered on a non-advised basis and we have not made personal recommendations. The cover offered is based on the information we obtained from you and reflects your demands and needs as a landlord who wishes to ensure they are protected against loss or damage to their property and/or contents for the term of the policy. The extent of your cover will depend on the specific options chosen by you. Please consult your quote schedule for full details of your cover and if you have any questions do not hesitate to contact us. We have given you sufficient information for you to make your own decision about how to proceed.</p>
                </div>
                <div className="container">
                    <div className="price-row">
                        <div className="price-column">
                            <div className="price-container">
                                <header>
                                    <h3>A single payment</h3>
                                </header>
                                <p>
                                    <span className="yearly-price price">&pound;<span className="price-value">
                                        {this.state.quote.premiums.annual.formatted.gross_inc_ipt_and_fee}
                                    </span></span>
                                </p>
                                <div className="view">
                                    <a href="#" onClick={this.openAnnualBreakdownModal}>View your premium breakdown</a>
                                </div>
                            </div>
                        </div>

                        <div className="price-column">
                            <div className="hidden-xs-down">
                                <span className="text--transform-uppercase text--align-centre">or</span>
                            </div>
                        </div>

                        <div className="price-column">
                            <div className="price-container">
                                <header>
                                    <h3>Monthly payments</h3>
                                </header>
                                <p>
                                    <span className="monthly-price price">&pound;<span className="price-value">
                                        {this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee}
                                    </span></span>
                                </p>
                                <div className="view">
                                    <a href="#" onClick={this.openMonthlyBreakdownModal}>View your premium breakdown</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <modal-container class={this.state.isAnnualBreakdownActive ? 'modal-active' : null}>
                        <modal>
                            <div className="modal-header">
                                Annual Premium Breakdown
                                <a className="close-cross" onClick={this.closeAnnualBreakdownModal}><FaCross /></a>
                            </div>
                            <div className="modal-body">
                                <table className="table table-condensed table-breakdown">
                                    <thead>
                                    <tr>
                                        <th>Cover</th>
                                        <th>Sum Insured</th>
                                        <th>Premium</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {/* Policy includes buildings cover */}
                                    {this.state.quote.need_building_insurance === 'yes' ?
                                        <tr>
                                            <td>
                                                Buildings {annualBuildingsAccidentalDamage > 0 ?
                                                <span> + Accidental Damage</span>
                                                : null}
                                            </td>
                                            <td>
                                                &pound;{this.state.quote.building_value ?
                                                <span>{this.state.quote.building_value}</span>
                                                : <span>500,000</span>}
                                            </td>
                                            <td>
                                                {annualBuildingsAccidentalDamage > 0 ?
                                                    <span>&pound;{(annualBuildings + annualBuildingsAccidentalDamage).toFixed(2)}</span>
                                                    :
                                                    <span>&pound;{(annualBuildings).toFixed(2)}</span>
                                                }
                                            </td>
                                        </tr>
                                    : null}

                                    {annualBuildingsFlood > 0 ?
                                        <tr>
                                            <td>Buildings Flood Cover</td>
                                            <td />
                                            <td>&pound;{annualBuildingsFlood.toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes contents cover */}
                                    {this.state.quote.need_contents_insurance === 'yes' ?
                                        <tr>
                                            <td>
                                                Contents {annualContentsAccidentalDamage > 0 ?
                                                <span> + Accidental Damage</span>
                                                : null}
                                            </td>
                                            <td>
                                                {this.state.quote.property_furnished === 'yes' ?
                                                    <span>&pound;{this.state.quote.contents_amount}</span>
                                                :
                                                    <span>&pound;5,000 (limited cover)</span>
                                                }
                                            </td>
                                            <td>
                                                {this.state.quote.property_furnished === 'yes' ?
                                                    <span>
                                                        {annualContentsAccidentalDamage > 0 ?
                                                            <span>&pound;{(annualFullContents + annualContentsAccidentalDamage).toFixed(2)}</span>
                                                            :
                                                            <span>&pound;{(annualFullContents).toFixed(2)}</span>
                                                        }
                                                    </span>
                                                :
                                                    <span>&pound;{(annualLimitedContents).toFixed(2)}</span>
                                                }
                                            </td>
                                        </tr>
                                    : null}

                                    {annualContentsFlood > 0 ?
                                        <tr>
                                            <td>Contents Flood Cover</td>
                                            <td />
                                            <td>&pound;{annualContentsFlood.toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes Boiler & Heating */}
                                    {annualBoilerAndHeating > 0 ?
                                        <tr>
                                            <td>Boiler &amp; Heating</td>
                                            <td>&pound;1500</td>
                                            <td>&pound;{annualBoilerAndHeating.toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes Emergency Assistance */}
                                    {annualEmergencyAssistance > 0 ?
                                        <tr>
                                            <td>Emergency Assistance</td>
                                            <td>&pound;1500</td>
                                            <td>&pound;{annualEmergencyAssistance.toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes Rent Guarantee */}
                                    {this.state.quote.need_prestige_rent_guarantee === 'yes' ?
                                        <tr>
                                            <td>Rent Guarantee &amp; Legal Expenses Limit of Indemnity</td>
                                            <td>&pound;50,000</td>
                                            <td>&pound;{(annualRentGuarantee).toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes Legal Expenses */}
                                    {this.state.quote.need_legal_expenses === 'yes' && this.state.quote.need_prestige_rent_guarantee === 'no' ?
                                        <tr>
                                            <td>Legal Expenses</td>
                                            <td>&pound;50,000</td>
                                            <td>
                                                {this.state.quote.need_prestige_rent_guarantee === 'yes' ?
                                                    <span>Free{/* included for free if Rent Guarantee is also on the policy */}</span>
                                                    :
                                                    <span>&pound;{annualLegalExpenses.toFixed(2)}</span>
                                                }
                                            </td>
                                        </tr>
                                    : null}
                                    </tbody>
                                    <tfoot>
                                    {/* IPT */}
                                    <tr>
                                        <td colSpan="2">Insurance Premium Tax</td>
                                        <td>&pound;{annualIpt.toFixed(2)}</td>
                                    </tr>
                                    {/* Total amount including IPT */}
                                    <tr>
                                        <td colSpan="2">Total payment</td>
                                        <td>
                                            <span className="price">&pound;{this.state.quote.premiums.annual.formatted.gross_inc_ipt_and_fee}</span>
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div className="modal-footer">
                                <a onClick={this.closeAnnualBreakdownModal} className="btn btn-default">OK</a>
                            </div>
                        </modal>
                    </modal-container>

                    <modal-container class={this.state.isMonthlyBreakdownActive ? 'modal-active' : null}>
                        <modal>
                            <div className="modal-header">
                                Monthly Premium Breakdown
                                <a className="close-cross" onClick={this.closeMonthlyBreakdownModal}><FaCross /></a>
                            </div>
                            <div className="modal-body">
                                <table className="table table-condensed table-breakdown">
                                    <thead>
                                    <tr>
                                        <th>Cover</th>
                                        <th>Sum Insured</th>
                                        <th>Premium</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {/* Policy includes buildings cover */}
                                    {this.state.quote.need_building_insurance === 'yes' ?
                                        <tr>
                                            <td>
                                                Buildings {annualBuildingsAccidentalDamage > 0 ?
                                                <span> + Accidental Damage</span>
                                                : null}
                                            </td>
                                            <td>
                                                &pound;{this.state.quote.building_value ?
                                                <span>{this.state.quote.building_value}</span>
                                                : <span>500,000</span>}
                                            </td>
                                            <td>
                                                {annualBuildingsAccidentalDamage > 0 ?
                                                    <span>&pound;{((annualBuildings + annualBuildingsAccidentalDamage) / 12).toFixed(2)}</span>
                                                    :
                                                    <span>&pound;{(annualBuildings / 12).toFixed(2)}</span>
                                                }
                                            </td>
                                        </tr>
                                    : null}

                                    {annualBuildingsFlood > 0 ?
                                        <tr>
                                            <td>Buildings Flood Cover</td>
                                            <td />
                                            <td>&pound;{(annualBuildingsFlood / 12).toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes contents cover */}
                                    {this.state.quote.need_contents_insurance === 'yes' ?
                                        <tr>
                                            <td>
                                                Contents {annualBuildingsAccidentalDamage > 0 ?
                                                <span> + Accidental Damage</span>
                                                : null}
                                            </td>
                                            <td>
                                                {this.state.quote.property_furnished === 'yes' ?
                                                    <span>&pound;{this.state.quote.contents_amount}</span>
                                                    :
                                                    <span>&pound;5,000 (limited cover)</span>
                                                }
                                            </td>
                                            <td>
                                                {this.state.quote.property_furnished === 'yes' ?
                                                    <span>
                                                        {annualContentsAccidentalDamage > 0 ?
                                                            <span>&pound;{((annualFullContents + annualContentsAccidentalDamage) / 12).toFixed(2)}</span>
                                                            :
                                                            <span>&pound;{(annualFullContents / 12).toFixed(2)}</span>
                                                        }
                                                    </span>
                                                :
                                                    <span>&pound;{(annualLimitedContents / 12).toFixed(2)}</span>
                                                }
                                            </td>
                                        </tr>
                                    : null}

                                    {annualContentsFlood > 0 ?
                                        <tr>
                                            <td>Contents Flood Cover</td>
                                            <td />
                                            <td>&pound;{(annualContentsFlood / 12).toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes Boiler & Heating */}
                                    {annualBoilerAndHeating > 0 ?
                                        <tr>
                                            <td>Boiler &amp; Heating</td>
                                            <td>&pound;1500</td>
                                            <td>&pound;{(annualBoilerAndHeating / 12).toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes Emergency Assistance */}
                                    {annualEmergencyAssistance > 0 ?
                                        <tr>
                                            <td>Emergency Assistance</td>
                                            <td>&pound;1500</td>
                                            <td>&pound;{(annualEmergencyAssistance / 12).toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes Rent Guarantee */}
                                    {this.state.quote.need_prestige_rent_guarantee === 'yes' ?
                                        <tr>
                                            <td>Rent Guarantee &amp; Legal Expenses Limit of Indemnity</td>
                                            <td>&pound;50,000</td>
                                            <td>&pound;{(annualRentGuarantee / 12).toFixed(2)}</td>
                                        </tr>
                                    : null}

                                    {/* Policy includes Legal Expenses */}
                                    {this.state.quote.need_legal_expenses === 'yes' && this.state.quote.need_prestige_rent_guarantee === 'no' ?
                                        <tr>
                                            <td>Legal Expenses</td>
                                            <td>&pound;50,000</td>
                                            <td>
                                                {this.state.quote.need_prestige_rent_guarantee === 'yes' ?
                                                    <span>Free{/* included for free if Rent Guarantee is also on the policy */}</span>
                                                    :
                                                    <span>&pound;{(annualLegalExpenses / 12).toFixed(2)}</span>
                                                }
                                            </td>
                                        </tr>
                                    : null}

                                    </tbody>
                                    <tfoot>
                                    {/* IPT */}
                                    <tr>
                                        <td colSpan="2">Insurance Premium Tax</td>
                                        <td>&pound;{(annualIpt / 12).toFixed(2)}</td>
                                    </tr>
                                    {/* Monthly admin fee */}
                                    <tr>
                                        <td colSpan="2">Monthly Administration Fee</td>
                                        <td>&pound;{(this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee - this.state.quote.premiums.monthly.formatted.gross_inc_ipt).toFixed(2)}</td>
                                    </tr>
                                    {/* Total amount including IPT */}
                                    <tr>
                                        <td colSpan="2">Total Monthly Payment</td>
                                        <td>
                                            <span className="price">&pound;{this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee}</span>
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div className="modal-footer">
                                <a onClick={this.closeMonthlyBreakdownModal} className="btn btn-default">OK</a>
                            </div>
                        </modal>
                    </modal-container>
                </div>

                <div className="container has-border">
                    <div className="form-group">
                        <div className="field-content">
                            <div className="benefits-row">
                            {localStorage.getItem('jpk') =='8' ?

                                (
                                <div className="benefits-row"> 
                                    <div className="benefits-column">
                                        <div className="building pad4" >
                                            <p className="buildingparagrah">Contents Insurance</p>
                                            
                                     
                                            <p className="pad4"><b>Furnished Properties (Full):</b></p>
                                           <div className="content">
                                            {/* <ul className="icon-list">
                                                <li><FaCheck className="icon success" />Variable cover levels starting at £10,000. </li>
                                                <li><FaCheck className="icon success" />Covers furnishings, fixtures and garden items. </li>
                                                <li><FaCheck className="icon success" />Optional Extras Accidental & Malicious damage by tenants. </li>
                                                <li><FaCheck className="icon success" />Upto £5millions property owners liability feature. </li>
                                        </ul> */}

                                      <table class="table">
                                        <tbody>
                                            <tr>
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Variable cover levels starting at £10,000.</td>
                                           
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Covers furnishings, fixtures and garden items.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Optional Extras Accidental & Malicious damage by tenants.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Upto £5millions property owners liability feature.</td>
                                            
                                            </tr>
                                           
                                            
                                        </tbody>
                                        </table>



                                        <br/>
                                            <div className="optionalextra">
                                                <span className="optionalextraspan">Optional Extras</span>
                                                <p> Accidental & Malicious damage by a tenant</p> 
                                                <p> Boiler & Heating cover.</p>
                                            </div>
                                            <p className="pad4"><b>Unfurnished Properties (Limited):</b></p>
                                        {/* <ul className="icon-list">
                                            <li><FaCheck className="icon success" />Cover for up to £5,000. </li>
                                            <li><FaCheck className="icon success" />Covers carpets, curtains, sun blinds, light fixtures and fitting and kitchen white goods. </li>
                                            <li><FaCheck className="icon success" />Upto £5 millions property owners liability feature. </li>
                                            </ul> */}

                                     <table class="table">
                                        <tbody>
                                            <tr>
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Cover for up to £5,000.</td>
                                           
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Covers carpets, curtains, sun blinds, light fixtures and fitting and kitchen white goods.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Upto £5 millions property owners liability feature.</td>
                                            
                                            </tr>
                                           
                                            
                                        </tbody>
                                        </table>



                                        </div>
                                 </div>
                                
                             </div>
                             {this.state.quote.property_furnished === 'yes' ?
                                                   <div className="benefits-column">
                                                   <div className="building pad4">
                                                       <p className="buildingparagrah">Emergency Assistance </p>
                                                       <div className="content-buildingboth">
                                               
                                                   <p className="pad4"><b>Emergency Assistance Insurance (Limited, included as standard):</b></p>
                                                   <table class="table">
                                                   <tbody>
                                                       <tr>
                                                       <th scope="row" className="vertical-align">&#10003;</th>
                                                       <td>Covers attendance of a contractor in an emergency situation, for emergencies in connection with; Plumbing & Drainage, Internal Electricity, Gas & Water Supplies, Security,</td>
                                                      
                                                       </tr>
                                                       <tr>
                                                       
                                                       <th scope="row" className="vertical-align">&#10003;</th>
                                                       <td>Up to £500 per claim, with a maximum claim amount in the cover period of £1,500.</td>
                                                       
                                                       </tr>
                                                       
                                                   </tbody>
                                                   </table>
           
                                                   <br/>
                                                   
                                               </div>
                                                   </div>
                                            </div>  
                                                :
                                                    <span></span>
                                                }
                              
              
</div>
                                )

                                :(localStorage.getItem('jpk') =='4') ?

                                    (
                                    <div className="benefits-row"> 
                                    <div className="benefits-column">
                                            <div className="building pad4">
                                                <p className="buildingparagrah">Building Insurance</p>
                                                {/* <ul className="icon-list">
                                                <li><FaCheck className="icon success" />Offers a standard rebuild value of up to £500,000. </li>
                                                <li><FaCheck className="icon success" />Loss of rent or alternative accommodation, including some re-letting costs, up to £50,000 following an insured loss.</li>
                                                <li><FaCheck className="icon success" />Up to 90 Days no-restriction in cover when the property is empty between tenancies.</li>
                                                <li><FaCheck className="icon success" />Up to £5millions property owner’s liability and up to £10m employer’s liability.</li>
                                                
                                                </ul> */}

                                       <table class="table">
                                        <tbody>
                                            <tr>
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Offers a standard rebuild value of up to £500,000.</td>
                                           
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Loss of rent or alternative accommodation, including some re-letting costs, up to £50,000 following an insured loss.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Up to 90 Days no-restriction in cover when the property is empty between tenancies.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Up to £5millions property owner’s liability and up to £10m employer’s liability.</td>
                                            
                                            </tr>
                                            
                                        </tbody>
                                        </table>




                                                <div className="optionalextra">
                                                    <span className="optionalextraspan">Optional Extras</span>
                                                    <p> Accidental & Malicious damage by a tenant.</p>
                                                    <p> Boiler & Heating cover.</p>
                                                </div>
                                                <br/> <br/>
                                            </div>
                                    </div>
                                    

                                    <div className="benefits-column">
                                                   <div className="building pad4">
                                                       <p className="buildingparagrah">Emergency Assistance </p>
                                                       <div className="content-emergency-benifit-only">
                                               
                                                   <p className="pad4"><b>Emergency Assistance Insurance (Limited, included as standard):</b></p>
                                                   <table class="table">
                                                   <tbody>
                                                       <tr>
                                                       <th scope="row" className="vertical-align">&#10003;</th>
                                                       <td>Covers attendance of a contractor in an emergency situation, for emergencies in connection with; Plumbing & Drainage, Internal Electricity, Gas & Water Supplies, Security,</td>
                                                      
                                                       </tr>
                                                       <tr>
                                                       
                                                       <th scope="row" className="vertical-align">&#10003;</th>
                                                       <td>Up to £500 per claim, with a maximum claim amount in the cover period of £1,500.</td>
                                                       
                                                       </tr>
                                                       
                                                   </tbody>
                                                   </table>
           
                                                   <br/>
                                                   
                                               </div>
                                                   </div>
                                            </div>  
                                    
                                    {/* {this.state.quote.property_furnished === 'yes' ?
                                                   <div className="benefits-column">
                                                   <div className="building pad4">
                                                       <p className="buildingparagrah">Emergency Assistance </p>
                                                       <div className="content-emergency-limited-only">
                                               
                                                   <p className="pad4"><b>Emergency Assistance Insurance (Limited, included as standard):</b></p>
                                                   <table class="table">
                                                   <tbody>
                                                       <tr>
                                                       <th scope="row" className="vertical-align">&#10003;</th>
                                                       <td>Covers attendance of a contractor in an emergency situation, for emergencies in connection with; Plumbing & Drainage, Internal Electricity, Gas & Water Supplies, Security,</td>
                                                      
                                                       </tr>
                                                       <tr>
                                                       
                                                       <th scope="row" className="vertical-align">&#10003;</th>
                                                       <td>Up to £500 per claim, with a maximum claim amount in the cover period of £1,500.</td>
                                                       
                                                       </tr>
                                                       
                                                   </tbody>
                                                   </table>
           
                                                   <br/>
                                                   
                                               </div>
                                                   </div>
                                            </div>  
                                                :
                                                    <span></span>
                                                }                         */}



</div>




                                    
                                    
                                    ) 

                                :
                                    (<div className="benefits-row"> 
                                        <div className="benefits-column">
                                                

                                                {this.state.quote.property_furnished === 'yes' ?
                                                    <div className="building pad4">
                                                    
                                                    <p className="buildingparagrah">Building Insurance</p>
                                                    <p></p>
                                                   
                                        <table class="table">
                                        <tbody>
                                            <tr>
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Offers a standard rebuild value of up to £500,000.</td>
                                           
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Loss of rent or alternative accommodation, including some re-letting costs, up to £50,000 following an insured loss.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Up to 90 Days no-restriction in cover when the property is empty between tenancies.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Up to £5millions property owner’s liability and up to £10m employer’s liability.</td>
                                            
                                            </tr>
                                            
                                        </tbody>
                                        </table>


                                                   
                                                    <div className="optionalextra">
                                                        <span className="optionalextraspan">Optional Extras</span>
                                                        <p> Accidental & Malicious damage by a tenant.</p>
                                                        <p> Boiler & Heating cover.</p>
                                                    </div>
                                                    <br/> <br/>
                                                </div>
                                                :
                                                <div className="content-emergency-limited-only building pad4">
                                                    
                                                <p className="buildingparagrah">Building Insurance</p>
                                                <p></p>
                                              
                                    <table class="table">
                                    <tbody>
                                        <tr>
                                        <th scope="row" className="vertical-align">&#10003;</th>
                                        <td>Offers a standard rebuild value of up to £500,000.</td>
                                       
                                        </tr>
                                        <tr>
                                        
                                        <th scope="row" className="vertical-align">&#10003;</th>
                                        <td>Loss of rent or alternative accommodation, including some re-letting costs, up to £50,000 following an insured loss.</td>
                                        
                                        </tr>
                                        <tr>
                                        
                                        <th scope="row" className="vertical-align">&#10003;</th>
                                        <td>Up to 90 Days no-restriction in cover when the property is empty between tenancies.</td>
                                        
                                        </tr>
                                        <tr>
                                        
                                        <th scope="row" className="vertical-align">&#10003;</th>
                                        <td>Up to £5millions property owner’s liability and up to £10m employer’s liability.</td>
                                        
                                        </tr>
                                        
                                    </tbody>
                                    </table>


                                               
                                                <div className="optionalextra">
                                                    <span className="optionalextraspan">Optional Extras</span>
                                                    <p> Accidental & Malicious damage by a tenant.</p>
                                                    <p> Boiler & Heating cover.</p>
                                                </div>
                                                <br/> <br/>
                                            </div>
                                                } 



                                          
                                        </div>
                                        
                                        <div className="benefits-column">
                                        <div className="building pad4">
                                            <p className="buildingparagrah">Contents Insurance</p>
                                            <div className="content">
                                            {/* <ul className="icon-list">
                                            <p className="pad4"><b>Furnished Properties (Full):</b></p>
                                                <li><FaCheck className="icon success" />Variable cover levels starting at £10,000. </li>
                                                <li><FaCheck className="icon success" />Covers furnishings, fixtures and garden items. </li>
                                                <li><FaCheck className="icon success" />Optional Extras Accidental & Malicious damage by tenants. </li>
                                                <li><FaCheck className="icon success" />Upto £5millions property owners liability feature. </li>
                                        </ul> */}
                                        <p className="pad4"><b>Furnished Properties (Full):</b></p>
                                        <table class="table">
                                        <tbody>
                                            <tr>
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Variable cover levels starting at £10,000.<br/></td>
                                           
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Covers furnishings, fixtures and garden items.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Upto £5millions property owners liability feature.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Optional Extras Accidental & Malicious damage by tenants.</td>
                                            
                                            </tr>
                                            
                                        </tbody>
                                        </table>






                                        <br/>
                                            <div className="optionalextra">
                                                <span className="optionalextraspan">Optional Extras</span>
                                                <p> Accidental & Malicious damage by a tenant</p> 
                                                <p> Boiler & Heating cover.</p>
                                            </div>
                                        {/* <ul className="icon-list">
                                            <p className="pad4"><b>Unfurnished Properties (Limited):</b></p>   
                                            <li><FaCheck className="icon success" />Cover for up to £5,000. </li>
                                            <li><FaCheck className="icon success" />Covers carpets, curtains, sun blinds, light fixtures and fitting and kitchen white goods. </li>
                                            <li><FaCheck className="icon success" />Upto £5 millions property owners liability feature. </li>
                                            </ul> */}

                                        <p className="pad4"><b>Unfurnished Properties (Limited):</b></p>   

                                            <table class="table">
                                        
                                        <tbody>
                                            <tr>
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Cover for up to £5,000.<br/></td>
                                           
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Covers carpets, curtains, sun blinds, light fixtures and fitting and kitchen white goods.</td>
                                            
                                            </tr>
                                            <tr>
                                            
                                            <th scope="row" className="vertical-align">&#10003;</th>
                                            <td>Upto £5 millions property owners liability feature.</td>
                                            
                                            </tr>
                                            
                                        </tbody>
                                        </table>
                                    </div>
                                        </div>
                                 </div>

                                 {this.state.quote.property_furnished === 'yes' ?
                                                   <div className="benefits-column">
                                                   <div className="content-emergency-limited-only building pad4">
                                                       <p className="buildingparagrah">Emergency Assistance </p>
                                                       <div className="content-emergency-limited-only">
                                               
                                                   <p className="pad4"><b>Emergency Assistance Insurance (Limited, included as standard):</b></p>
                                                   <table class="table">
                                                   <tbody>
                                                       <tr>
                                                       <th scope="row" className="vertical-align">&#10003;</th>
                                                       <td>Covers attendance of a contractor in an emergency situation, for emergencies in connection with; Plumbing & Drainage, Internal Electricity, Gas & Water Supplies, Security,</td>
                                                      
                                                       </tr>
                                                       <tr>
                                                       
                                                       <th scope="row" className="vertical-align">&#10003;</th>
                                                       <td>Up to £500 per claim, with a maximum claim amount in the cover period of £1,500.</td>
                                                       
                                                       </tr>
                                                       
                                                   </tbody>
                                                   </table>
           
                                                   <br/>
                                                   
                                               </div>
                                                   </div>
                                            </div>  
                                                :
                                                    <span></span>
                                                }                          




                                    </div>) 
                                }
                               
                                <div className="benefits-column displaynone">
                                    <h4>Further information</h4>
                                    <ul className="icon-list">
                                        <li><FaFilePdfO className="icon" /><a href="https://homelet.co.uk/assets/documents/Landlord-Insurance-Plus/HL5259-Landlords-Insurance+-IPID-1022-compressed.pdf" target="_blank">Insurance Product Information Document</a></li>
                                        <li><FaFilePdfO className="icon" /><a href="https://homelet.co.uk/assets/documents/Landlord-Insurance-Plus/Landlords-Insurance+-IDD-1022.pdf" target="_blank">Initial Disclosure Document</a></li>
                                        <li><FaFilePdfO className="icon" /><a href="https://homelet.co.uk/downloads/hl-ll-pw" target="_blank">Policy Wording</a></li>
                                    
                                    
                                    </ul>
                                </div>
                            </div>
                            <ul className="icon-list margin">
                                       <li><FaCheck className="icon success" />Variable excess options are available for full Contents insurance. </li>
  
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="container has-border">
                    <div className="summary-row">
                        <div className="summary-column">
                            <h3 id="your-cover">Your cover</h3>
                            <dl className="dl-horizontal">
                                <dt>Covers on this policy</dt>
                                <dd>
                                    {this.getCoversOnPolicyFormattedString()}
                                </dd>
                                <dt>Start date</dt>
                                <dd>{this.state.quote.policy_start}</dd>
                                <dt>Length of cover</dt>
                                <dd>12 months</dd>
                            </dl>
                        </div>
                    </div>
                </div>

                {/* Policy includes buildings cover */}
                {this.state.quote.need_building_insurance === 'yes' ?
                    <div>
                        <div className="container has-border">
                            <div className="summary-row">
                                <div className="summary-column">
                                    <h3 id="your-cover">Amount of buildings cover</h3>
                                    <dl className="dl-horizontal">
                                        <dt>Sum insured</dt>
                                        <dd>
                                            &pound;{this.state.quote.building_value ?
                                            <span>{this.state.quote.building_value}</span>
                                            : <span>500,000 (included as standard)</span>}
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>

                        {/* Buildings accidental damage extension */}
                        <div className="container has-border">
                            <div className="summary-row">
                                <div className="summary-column">
                                    <h3 id="your-cover">Buildings Accidental Damage extension</h3>
                                    {annualBuildingsAccidentalDamage > 0 ?
                                        <div>
                                            <p>This includes cover for loss or damage to your property caused by a malicious act by your tenants. For full details and exclusions please see our <a href="https://homelet.co.uk/downloads/hl-ll-pw" target="_blank">Policy Wording</a>.</p>
                                            <dl className="dl-horizontal">
                                                <dt>Sum insured</dt>
                                                {this.state.quote.building_value ?
                                                    <dd>&pound;{this.state.quote.building_value}</dd>
                                                : <dd>&pound;500,000</dd>}
                                            </dl>
                                        </div>
                                    :
                                        <p>Not included in this policy. Click 'edit' to change.</p>
                                    }
                                </div>
                                <div className="summary-column">
                                    <span onClick={this.showBuildingsAccidentalDamageField} className="btn btn-default field-edit">Edit</span>
                                </div>
                            </div>
                            {this.state.isShowBuildingsAccidentalDamageField ?
                                <BuildingsAccidentalDamage
                                    regenerateQuote={this.regenerateQuote}
                                 />
                            : null}
                        </div>

                        {/* Buildings excess */}
                        <div className="container has-border">
                            <div className="summary-row">
                                <div className="summary-column">
                                    <h3 id="your-cover">Excess for your buildings cover</h3>
                                    <dl className="dl-horizontal">
                                        <dt>Standard Excess</dt>
                                        <dd>&pound;{this.state.quote.building_insurance_excess}</dd>
                                    </dl>
                                </div>
                                <div className="summary-column">
                                    <span onClick={this.showExcessBuildingsCoverField} className="btn btn-default field-edit">Edit</span>
                                </div>
                            </div>
                            <div className="summary-row">
                                <div className="summary-column">
                                    {this.renderExcessStaticText('Buildings')}
                                </div>
                            </div>
                            {this.state.isShowExcessBuildingsCoverField ?
                                <ExcessBuildingsCover
                                    regenerateQuote={this.regenerateQuote}
                                />
                            : null}
                        </div>
                    </div>
                : null}

                {/* Policy includes contents cover */}
                {this.state.quote.need_contents_insurance === 'yes' ?
                    <div>
                        {this.state.quote.property_furnished === 'yes' ?
                            <div>
                                <div className="container has-border">
                                    <div className="summary-row">
                                        <div className="summary-column">
                                            <h3 id="your-cover">Amount of contents cover</h3>
                                            <dl className="dl-horizontal">
                                                <dt>Sum insured</dt>
                                                {this.state.quote.contents_amount ?
                                                    <dd>&pound;{this.state.quote.contents_amount}</dd>
                                                    : null}
                                            </dl>
                                        </div>
                                        <div className="summary-column" />
                                    </div>
                                </div>

                                {/* Policy has contents accidental damage extension */}
                                <div className="container has-border">
                                    <div className="summary-row">
                                        <div className="summary-column">
                                            <h3 id="your-cover">Contents Accidental Damage extension</h3>
                                            <p>This includes cover for loss or damage to your property caused by a malicious act by your tenants. For full details and exclusions please see our <a href="https://homelet.co.uk/downloads/hl-ll-pw" target="_blank">Policy Wording</a>.</p>
                                            {annualContentsAccidentalDamage > 0 ?
                                                <dl className="dl-horizontal">
                                                    <dt>Sum insured</dt>
                                                    <dd>&pound;{this.state.quote.contents_amount}</dd>
                                                </dl>
                                            :
                                                <p>Not included in this policy. Click 'edit' to change.</p>
                                            }
                                        </div>
                                        <div className="summary-column">
                                            <span onClick={this.showContentsAccidentalDamageField} className="btn btn-default field-edit">Edit</span>
                                        </div>
                                    </div>
                                    {this.state.isShowContentsAccidentalDamageField ?
                                        <ContentsAccidentalDamage
                                            regenerateQuote={this.regenerateQuote}
                                        />
                                    : null}
                                </div>

                                {/* Contents excess */}
                                <div className="container has-border">
                                    <div className="summary-row">
                                        <div className="summary-column">
                                            <h3 id="your-cover">Excess for your contents cover</h3>
                                            <dl className="dl-horizontal">
                                                <dt>Standard Excess</dt>
                                                <dd>&pound;{this.state.quote.contents_excess}</dd>
                                            </dl>
                                        </div>
                                        <div className="summary-column">
                                            <span onClick={this.showExcessContentsCoverField} className="btn btn-default field-edit">Edit</span>
                                        </div>
                                    </div>
                                    <div className="summary-row">
                                        <div className="summary-column">
                                            {this.renderExcessStaticText('Contents')}
                                        </div>
                                    </div>
                                    {this.state.isShowExcessContentsCoverField == true ?
                                        <ExcessContentsCover
                                            regenerateQuote={this.regenerateQuote}
                                        />
                                    : null}
                                </div>
                            </div>
                        :
                            <div className="container has-border">
                                {/* Limited contents only */}
                                <div className="summary-row">
                                    <div className="summary-column">
                                        <h3 id="your-cover">Limited Contents Cover</h3>
                                        <p>Limited Contents includes a fixed Sum Insured of &pound;5,000 for carpets, curtains, blinds, light fittings and kitchen white goods. The Excess applicable for this cover are:</p>
                                        <ul>
                                            <li>&pound;250 for standard perils</li>
                                            <li>&pound;500 for Malicious Act by a third party</li>
                                            <li>&pound;1,000 for Subsidence, Landslip or Heave</li>
                                        </ul>
                                        <p>For full Exclusions, Limitations and Conditions please refer to the <a href="https://homelet.co.uk/downloads/hl-ll-pw" target="_blank">Policy Wording</a>.</p>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                : null}

                {Quote.getCurrentAnswer('include_flood_cover') && (this.state.quote.property_furnished === 'yes' || this.state.quote.need_building_insurance === 'yes') ?
                    <div className="container has-border">
                        {/* Medium risk property, can change whether or not they want flood cover */}
                        <div className="summary-row">
                            <div className="summary-column">
                                <h3 id="your-cover">Flood cover for your property</h3>
                                {Quote.getCurrentAnswer('include_flood_cover') === 'yes' ?
                                    <p>You have selected flood cover for this property.</p>
                                    :
                                    <p>You have chosen <span className="text--transform-uppercase">not</span> to include flood cover for this property.</p>
                                }
                            </div>
                            <div className="summary-column">
                                <span onClick={this.showIncludeFloodCoverField} className="btn btn-default field-edit">Edit</span>
                            </div>
                        </div>
                        {this.state.isShowIncludeFloodCoverField == true ?
                            <IncludeFloodCover
                                regenerateQuote={this.regenerateQuote}
                            />
                        : null}
                    </div>
                : null}

                {/* Policy includes Rent Guarantee + Legal Expenses */}
                {this.state.quote.need_prestige_rent_guarantee === 'yes' ?
                    <div className="container has-border">
                        <div className="summary-row">
                            <div className="summary-column">
                                <h3 id="your-cover">Rent Guarantee & Legal Expenses</h3>
                                <dl className="dl-horizontal">
                                    <dt>Rent Guarantee &amp; Legal Expenses Limit of Indemnity</dt>
                                    <dd>&pound;50,000</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                : null}

                {/* Policy includes Legal Expenses WITHOUT Rent Guarantee */}
                {this.state.quote.need_legal_expenses === 'yes' && this.state.quote.need_prestige_rent_guarantee === 'no' ?
                    <div className="container has-border">
                        <div className="summary-row">
                            <div className="summary-column">
                                <h3 id="your-cover">Legal Expenses</h3>
                                <dl className="dl-horizontal">
                                    <dt>Legal Expenses Sum insured</dt>
                                    <dd>&pound;50,000</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                : null}

                {(this.state.quote.need_prestige_rent_guarantee === 'yes' || this.state.quote.need_legal_expenses === 'yes') && (this.state.quote.need_building_insurance === 'no' && this.state.quote.need_contents_insurance === 'no') ?
                    null // no upsells
                    :

                    <div className="container has-border">
                        <div className="summary-row">
                            <div className="summary-column">
                                <h2>Choose your optional extras</h2>

                                {/* <p> As a part of this quote, we have included Emergency Assistance cover for 
                                unexpected emergency relating to the plumbing and drainage, electricity supply, cooking systems, security of windows and doors, lost keys, roofing downpiping and guttering or boiler & centeral heating system
                                </p><p>In the event of an insured emergency, we&rsquo;ll arrange a qualified contractor to come to the property as soon as possible subject to avialability and weather conditions
                                </p><p>Cover up to a maximum of £500 including VAT for each emergency; covering call out charges, three hours labour, parts and materials including VAT, with no excess to pay
                                </p><p>Cover up to £250 for a single night of accomodation where the property is uninhabitable due to the emergency
                                </p><p>Cover for up to £1,500 per policy term
                                </p><p>Emergency Assistance cover is only available for properties and equipment, which are well maintained and in a good state of repair	
                                </p><p>Terms and Conditions apply, please refer to the <a className="primary-colour underline" href="https://homelet.co.uk/downloads/hl-ll-pw" target="_blank">Policy Wording</a> for full details.</p>
                                 */}
                                
                            </div>
                            
                        </div>
                        {/* Contents (limited) with no buildings = Emergency Assistance */}
                        {this.state.quote.need_contents_insurance === 'yes' && this.state.quote.property_furnished === 'no' && this.state.quote.need_building_insurance === 'no' ?
                            <promo>
                                <div className="row">
                                    <div className="column">
                                        <FaMedkit className="pull-left main-icon" />
                                    </div>

                                    <div className="column">
                                        <h3>Emergency Assistance cover</h3>
                                        <p>As a part of this quote, we have included Emergency Assistance cover for unexpected emergency's relating to the plumbing & drainage,internal electricity, gas supply, water supply, security, access to the property, pests, roofing and primary heating system.
                                        </p>
                                        <ul className="icon-list">
                                            <li>
                                                <FaCheck className="icon quaternary" />In the event of an insured emergency, we&rsquo;ll arrange a qualified contractor to come to the property as soon as possible subject to avialability and weather conditions
                                            </li>
                                            <li>
                                                <FaCheck className="icon quaternary" />Cover up to a maximum of £500 including VAT for each emergency; covering call out charges, three hours labour, parts and materials including VAT, with no excess to pay
                                            </li>
                                            
                                            <li>
                                                <FaCheck className="icon quaternary" />Cover for up to £1,500 per policy term
                                            </li>
                                            <li>
                                                <FaCheck className="icon quaternary" />Emergency Assistance cover is only available for properties and equipment, which are well maintained and in a good state of repair	
                                            </li>
                                            <li>
                                                <FaCheck className="icon quaternary" />After 7 days from the policy start date, cover for Boilers (excluding renewable sources) and Central Heating Systems up to 15 years old that are serviced annually
                                            </li>
                                             </ul>
                                        <p>Terms and Conditions apply, please refer to the <a className="primary-colour underline" href="https://homelet.co.uk/downloads/hl-ll-pw" target="_blank">Policy Wording</a> for full details.</p>
                                    </div>
                                </div>

                                <footer>
                                    <div className="row">
                                        <div className="column">
                                            Would you like to add emergency assistance cover for <span className="base-colour">&pound;5.49per month (&pound;65.83 per year)?</span>
                                        </div>

                                        <div className="column">
                                            <AddonSelection
                                                field="need_emergency_assistance"
                                                regenerateQuote={this.regenerateQuote}
                                            />
                                        </div>
                                    </div>
                                </footer>
                            </promo>
                            :
                            <promo>
                                {/* Everything else = Boiler & Heating */}
                                <div className="row">
                                    <div className="column">
                                        <FaWrench className="pull-left main-icon" />
                                    </div>

                                    <div className="column">
                                        <h3>Boiler and Heating cover</h3>
                                        <p>Your cover includes the Emergency Assistance Insurance detailed above as standard </p>                                       <ul className="icon-list">
                                            <li>
                                                <FaCheck className="icon quaternary" />If selected, after 7 days from the policy start date, this optional extra provides cover for emergency repairs following the complete breakdown of the primary heating system.
                                            </li>
                                            <li>
                                            
                                                <FaCheck className="icon quaternary" />In the event of an insured emergency, we&rsquo;ll arrange for a qualified contractor to come to the property as soon as possible; subject to availability and weather conditions.
                                            </li>
                                            <li>
                                                <FaCheck className="icon quaternary" />Cover up to a maximum of £500, including VAT, for each emergency.
                                            </li>
                                            <li>
                                                <FaCheck className="icon quaternary" />Cover for up to £1,500 per policy term for the Emergency Assistance and Boiler and Heating cover in total.
                                            </li>
                                            <li>
                                                <FaCheck className="icon quaternary"/>Cover for up to £50 towards costs of alternative heating where this is deemed necessary.
                                            </li>
                                            <li>
                                                <FaCheck className="icon quaternary"/>A contribution towards a replacement boiler should this be deemed beyond uneconomical repair.
                                            </li>
                                        </ul>
                                        <p>Terms and Conditions apply, please refer to the <a className="primary-colour underline" href="https://homelet.co.uk/downloads/hl-ll-pw" target="_blank">Policy Wording</a>  for full details.</p>
                                    </div>
                                </div>

                                <footer>
                                    <div className="row">
                                        <div className="column">
                                            { /* todo: message to change if they select the upsell */ }
                                            Would you like to add boiler and heating cover for <span className="base-colour">only &pound;3.61 per month (&pound;43.27 per year)?</span>
                                        </div>

                                        <div className="column">
                                            <AddonSelection
                                                field="need_boiler_heating"
                                                regenerateQuote={this.regenerateQuote}
                                            />
                                        </div>
                                    </div>
                                </footer>
                            </promo>
                        }
                    </div>
                }

                <div className="alternate-background">
                    <div className="container">
                        <div className="summary-row">
                            <div className="summary-column">
                                <h3>Your details</h3>
                                <ul className="list-unstyled">
                                    <li>Name: {(this.state.quote.other_title) ? this.state.quote.other_title : this.state.quote.title } {this.state.quote.first_name} {this.state.quote.last_name}</li>
                                    <li>DOB: {this.state.quote.date_of_birth_at}</li>
                                    <li>E-mail: {this.state.quote.email_address}</li>
                                    <li>Phone: {this.state.quote.phone_number}</li>
                                </ul>
                            </div>

                            <div className="summary-column">
                                <h3>Your property</h3>
                                <h4>Insured address:</h4>
                                <ul className="list-unstyled">
                                    <li>{this.state.quote.ins_address_line1}</li>
                                    <li>{this.state.quote.ins_address_line2}</li>
                                    <li>{this.state.quote.ins_address_line3}</li>
                                    <li>{this.state.quote.ins_address_postcode}</li>
                                </ul>

                                <h4>Correspondence address:</h4>
                                <ul className="list-unstyled">
                                    <li>{this.state.quote.cor_address_line1}</li>
                                    <li>{this.state.quote.cor_address_line2}</li>
                                    <li>{this.state.quote.cor_address_line3}</li>
                                    <li>{this.state.quote.cor_address_postcode}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* { !this.isValid ?
                                    <p style={{ color: 'red' , margin: '0px 0px 0px 650px'}}>
                                       *  Please ensure checkbox to be checked to go to payment section.
                                    </p>
                                : null
                            } */}

                <div className="container">
                    <div className="summary-row">
                        <div className="summary-column">
                            <br/>
                            <table> 
                                <tr> 
                                    <td> 
                                        <input type="checkbox"  className="checkboxcheck" name="termsAndConditions" value="ps" checked={this.state.termsAndConditions.ps} onChange={this.checkboxHandler}/> 
                                    </td>
                                    <td>
                                        <label>Yes - I confirm that I have read the complete <a className="underline" onClick={this.QuotePackDoc}>quote pack</a> in full, which contains:</label> 
                                    </td> 
                                </tr> 
                                </table> 
                                
                                <ul>
                                <li> <label>Policy Summary</label> </li>
                                    <li> <label>Policy Wording</label> </li>
                                    <li> <label>Terms of Business</label> </li>
                                    <li> <label>Quote Schedule</label> </li>
                                    <li> <label>Important Information and Statement of Fact</label> </li>
                                </ul>

                            <div className="footer-contact hidden-xs-down">
                                <div className="call">
                                    <span className="primary-colour">Call us on</span> <br className="hidden-sm-down" />
                                    <span className="phone-number"><span itemProp="telephone"><a href="tel:0800 038 4574">0800 038 4574</a></span></span>
                                </div>
                                <div className="open-hours hidden-sm-down">
                                    <span className="pull-left">Weekdays</span>
                                    <span className="pull-right">8:30am - 5:30pm</span>
                                    <div className="clearfix" />
                                    <span className="pull-left">Saturday</span>
                                    <span className="pull-right">9:30am - 1:00pm</span>
                                </div>
                            </div>
                            <SubmitButton disabled={!this.IsContinueToPayment} 
                                label="Continue to Payment"
                                backLink={this.moveBack}
                                saveForLater={true}
                                onClick={this.goToPayment}
                            />
                        </div>
                    </div>
                </div>
                {this.state.isShowPageSpinner ?
                    <PageSpinnerModal
                        ref="PageSpinnerModal"
                        message={this.state.pageSpinnerMessage}
                    />
                : null}
            </div>
        );
    }
});

export default QuoteSummaryScreen;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/QuoteSummaryScreen.js
 **/